import { mapProduct } from "./mapProduct";
import { insertIntoArray } from "./insertIntoArray";
import { setTileIds } from "./setTileIds";
import { setSponsoredProductRanks } from "../../setSponsoredProductRanks";

export const mapAndInsertProducts = ({
  existingProducts,
  existingExtraItemCount,
  pageSize,
  offset,
  products,
  pageNumber,
  itemCount,
  insertionIndex,
  sponsoredCampaignId
}) => {
  let newProducts = products.map(product => {
    const isSponsored = product.sponsoredCampaignId !== null;

    return {
      ...mapProduct({ product }),
      pageNumber,
      isSponsored,
      sponsoredCampaignId: isSponsored ? sponsoredCampaignId : null,
      facetGroupings: product.facetGroupings
    };
  });

  const existingItemCount = existingProducts.length;
  const newItemCount = existingItemCount + newProducts.length;
  const maxIndicatedByApi = itemCount - offset.initial;
  const totalExpected = Math.min(
    existingItemCount + pageSize,
    maxIndicatedByApi + existingExtraItemCount
  );
  const extraItemCount =
    existingExtraItemCount + (newItemCount - totalExpected);

  newProducts = insertIntoArray({
    existingProducts,
    newProducts,
    insertionIndex
  });
  setTileIds(newProducts);
  newProducts = setSponsoredProductRanks(newProducts, offset.lower);

  return { products: newProducts, extraItemCount };
};
